<template>
  <div class="content main-container">
    <div class="search-box">
      <div class="input-item">
        <span class="label">分类名称</span>
        <Input v-model="searchParams.name" placeholder="请输入分类名称" clearable />
      </div>
      <div class="input-item">
        <span class="label">是否启用</span>
        <RadioGroup v-model="searchParams.isShow" @on-change="getList()">
          <Radio label="">全部</Radio>
          <Radio label="1">是</Radio>
          <Radio label="0">否</Radio>
        </RadioGroup>
      </div>
      <Button type="primary" @click="getList()">查询</Button>
      <Button type="primary" ghost @click="resetSearch()">重置</Button>
    </div>
    <Button type="primary" class="btn" @click="addType()" v-if="$units.pointAction('content_3_2_1')">+新建</Button>
    <div class="tableBox">
      <loading :isShow="tableLoading" />
      <Table :columns="columns" :data="tableData" row-key="id">
        <template slot-scope="{ row }" slot="isShow">
          <div @click="editDeail(row)">
            <i-switch v-model="row.isShow" true-value="1" false-value="0" :disabled="$units.pointAction('content_3_2_2')?false:true">
              <span slot="open">是</span>
              <span slot="close">否</span>
            </i-switch>
          </div>
        </template>
        <template slot-scope="{ row, index }" slot="move">
          <div v-if="$units.pointAction('content_3_2_2')">
            <span v-if="index != 0" class="table-btn"><i class="iconfont iconyidong-xiangshang"
                @click="moveType(row, '1')"></i></span>
            <span v-if="row._length != index + 1" class="table-btn"><i class="iconfont iconyidongxiangxia"
                @click="moveType(row, '2')"></i></span>
            <span v-if="index != 0" class="table-btn"><i class="iconfont iconyidong-zhiding"
                @click="moveType(row, '3')"></i></span>
            <span v-if="row._length != index + 1" class="table-btn"><i class="iconfont iconyidong-zhidi"
                @click="moveType(row, '4')"></i></span>
          </div>
        </template>
        <template slot-scope="{ row }" slot="action">
          <div>
            <span class="table-btn" @click="addType(row)" v-if="$units.pointAction('content_3_2_2')">修改</span>
            |
            <span class="table-btn" @click="deleteType(row.id)" v-if="$units.pointAction('content_3_2_3')">删除</span>
          </div>
        </template>
      </Table>
    </div>
    <Modal v-model="visible" :title="title" :mask-closable="false" :footer-hide="true">
      <Form ref="form" :model="formData" :label-width="80" class="formGauge">
        <FormItem label="栏目名称" prop="name" :rules="$units.formRule.required('请输入栏目名称')">
          <Input v-model="formData.name" placeholder="请输入" clearable />
        </FormItem>
        <FormItem label="父级" prop="parentId" v-if="changeType" key="parentId">
          <Select v-model="formData.parentId" transfer placeholder="请选择" clearable filterable>
            <Option v-for="(item, index) in parentList" :value="item.id" :key="index">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="是否启用" prop="isShow">
          <i-switch v-model="formData.isShow" true-value="1" false-value="0">
            <span slot="open">是</span>
            <span slot="close">否</span>
          </i-switch>
        </FormItem>
      </Form>
      <div class="ivu-modal-footer">
        <Button type="text" @click="visible = false">取消</Button>
        <Button type="primary" @click="submit" v-preventReClick>确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { pageTool } from "@/api/mixins";
export default {
  mixins: [pageTool],
  data() {
    return {
      tableLoading: false, //表格loading
      searchParams: {
        isShow: ''
      },
      title: '新增分类',
      visible: false,
      columns: [
        {
          title: "分类名称",
          tree: true,
          key: 'name',
        },
        {
          title: "是否启用",
          slot: 'isShow',
          align: 'center'
        },
        {
          title: '移动',
          slot: 'move',
          align: 'center'
        },
        {
          title: "更新时间",
          key: 'updateTime',
          minwidth: 180,
          align: 'center',
        },
        {
          title: "操作",
          slot: "action",
          align: 'center',
          width: 160,
        }
      ],
      tableData: [],
      parentList: [],
      formData: {
        isShow: '1'
      },
      changeType:true
    }
  },
  created() {
    if (!this.$units.pointAction('content_3_2_2') && !this.$units.pointAction('content_3_2_3')) {
      this.columns.splice(this.columns.length - 1, 1);
    }
    this.searchAjax();
  },
  methods: {
    moveType(row, type) {
      this.$http({
        url: '/buz/cmsColumn/moveColumnOrderNum',
        type: "POST",
        data: {
          id: row.id,
          type: type,
          parentId: row.parentId
        },
      }).then(res => {
        this.getList()
      })
    },
    deleteType(id) {
      this.$notice.inquiry('确认删除操作？').then(async () => {
        this.$http({
          url: '/buz/cmsColumn/del',
          type: "GET",
          data: {
            id: id
          },
        }).then(res => {
          this.getList()
        })
      })
    },
    editDeail(row) {
      this.$http({
        url: '/buz/cmsColumn/edit',
        type: "POST",
        data: row,
      }).then(res => {
        this.getList()
      })
    },
    addType(row) {
      this.visible = true
      this.$refs.form && this.$refs.form.resetFields();
      this.parentList = []
      this.changeType = true
      if (row) {
        this.title = '编辑分类'
        this.$http({
          url: '/buz/cmsColumn/read/detail',
          type: "GET",
          data: {
            id: row.id
          },
        }).then(res => {
          this.formData = res.data
        })
        this.tableData.forEach((item) => {
          if (item.id != row.id) {
            this.parentList.push(item)
          }
        })
        if(row.children.length>0){
          this.changeType = false
        }else{
          this.changeType = true
        }
      } else {
        this.title = '新增分类'
        this.formData = {
          isShow: '1'
        }
        this.parentList = this.tableData
      }
    },
    searchAjax() {
      this.pageNum = 1;
      this.getList();
    },
    submit() {
      if(!this.formData.parentId){
        this.formData.parentId = 0
      }
      this.$refs.form.validate(valid => {
        if (valid) {
          this.$http({
            url: this.formData.id ? '/buz/cmsColumn/edit' : '/buz/cmsColumn/add',
            type: "POST",
            data: {
              type: 3,
              ...this.formData
            },
          }).then(res => {
            this.$notice.success('操作成功');
            this.visible = false
            this.getList()
          })
        }
      });
    },
    // 获取列表数据
    getList() {
      this.tableLoading = true;
      this.$http({
        url: '/buz/cmsColumn/read/list',
        type: 'post',
        data: {
          type: 3,
          ...this.searchParams,
          pageSize : 999
        },
      })
        .then(res => {
          this.tableLoading = false;
          this.tableData = this.handleTableTree(res.data);
        })
        .catch(e => {
          this.tableLoading = false;
        });
    },
    // 处理树形数据
    handleTableTree(arr) {
      return arr.map((item, index) => ({
        ...item,
        _showChildren: true,
        _length: item.parentId == '0' ? arr.length : arr.length,
        children: item.children ? this.handleTableTree(item.children) : []
      }));
    },
  }
}
</script>

<style lang="scss" scoped>
.btn {
  margin-bottom: 10px;
}
/deep/ .ivu-switch:focus{
  box-shadow:0 0 0 0;
}
</style>